import { FC } from "react";
import * as ModalSlideUpStyled from "./ModalSlideUp.styled";
import * as Styled from "./ModalTitleComponent.styled";

export const ModalTitleComponent: FC<{ children?: React.ReactNode; strong?: boolean; handleClose?: () => void }> = ({
    children,
    handleClose,
}) => {
    return (
        <Styled.ModalDialogTitleStack>
            <ModalSlideUpStyled.ModalDialogTitleText>{children}</ModalSlideUpStyled.ModalDialogTitleText>
            <ModalSlideUpStyled.ModalCloseButton
                onClick={() => {
                    handleClose?.();
                }}
            />
        </Styled.ModalDialogTitleStack>
    );
};
